<template>
    <div>
        <!--      bulk-->
        <div v-if="userType == 'admin'">
            <div
                    v-for="item in SystemBulkReportSubMenu"
                    :key="item.index"
                    class="menu-item"
                    :class="{ active: item.route == currentRouteName }"
                    @click="changeRoute(item.route)"
            >
                <span class="item-text">{{ item.text }}</span>
            </div>
        </div>

        <div v-if="userType == 'company_admin'">
            <div
                    v-for="item in CompanyBulkReportSubMenu"
                    :key="item.index"
                    class="menu-item"
                    :class="{ active: item.route == currentRouteName }"
                    @click="changeRoute(item.route)"
            >
                <span class="item-text">{{ item.text }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { ListIcon, NavigationIcon,PieChartIcon,InboxIcon,LayoutIcon, BriefcaseIcon } from 'vue-feather-icons'

    export default {
        props: ["icon", "text", "route"],
        components: {
            ListIcon,
            NavigationIcon,
            PieChartIcon,
            InboxIcon,
            LayoutIcon,
            BriefcaseIcon
        },
        data: () => ({
            subMenu: null,
            userType: null,
            featherIcon: '',
            SystemBulkReportSubMenu: [
                {
                    route: "system-admin-bulk-report",
                    text: "Bulk Report",
                    icon: '',
                    featherIcon: 'layout-icon',
                },
                {
                    route: "system-admin-bulk-auto-substitute-report",
                    text: "Auto Substitute Bulk Report",
                    icon: '',
                    featherIcon: 'inbox-icon'
                },
                {
                    route: "system-admin-bulk-sms",
                    text: "Bulk Sms",
                    icon: '',
                    featherIcon: 'briefcase-icon'
                },
            ],
            CompanyBulkReportSubMenu: [
                {
                    route: "company-admin-bulk-report",
                    text: "Bulk Report",
                    icon: '',
                    featherIcon: 'layout-icon',
                },
                {
                    route: "company-admin-bulk-auto-substitute-report",
                    text: "Auto Substitute Bulk Report",
                    icon: '',
                    featherIcon: 'inbox-icon'
                },
                {
                    route: "company-admin-bulk-sms",
                    text: "Bulk Sms",
                    icon: '',
                    featherIcon: 'briefcase-icon'
                },
            ],
        }),
        created() {
            this.userType = this.$store.getters.userType;
        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            },
        },

        methods: {
            changeRoute(item) {
                this.$router.push({ name: item });
            },
        },
    };
</script>
<style lang="scss" scoped>
    .menu-item {
        display: flex;
        align-items: center;
        margin-left: 28px;
        margin-right: 10px;
        padding-left: 5px;
        border-radius: 3px;
        cursor: pointer;
        padding-top: .25rem;
        padding-bottom: .25rem;

        .custom-class{
            margin-right: .5rem;
            width: 25px;
            color: #1e1f20;

        }
        span:not(.custom-class) {
          font-size: 12px;
          color: #55616e;
          line-height: 20px;
          margin-left: 13px;
        }
        svg:not(.custom-class) {
            fill: #55616e;
            margin-right: 5px;
        }
    }
    .active {
        span {
            color: #7A89FE !important;
        }
    }
</style>